import {useContext, useEffect, useRef, useState} from "react";

// Context
import {UserAuthenticationContext} from "../../../../Context/UserAuthenticationContext";

// Helpers
import {SetTitle} from "../../../../Helpers/PageMetadata";

// Components
import SliderFeaturedContent from "../../../../Components/Layouts/Content/SliderFeaturedContent";
import VideoContentGridLandscape
    from "../../../../Components/Layouts/Content/Watch/VideoFeed/VideoContentGridLandscape";

// Hooks
import useFetchFilms from "../../../../Hooks/Content/Watch/VideoFeed/useFetchFilms";

function FilmsFeed() {
    const
        {userData} = useContext(UserAuthenticationContext),

        TAKE = 50,
        [skip, setSkip] = useState(0),

        // important: append for every page after the first
        shouldAppendData = skip > 0,

        {films, filmsLoading, filmsError} = useFetchFilms(TAKE, skip, shouldAppendData),

        // Prevent runaway loops / double-requests caused by React 18 StrictMode dev behavior
        lastRequestedSkipRef = useRef<number | null>(null),

        // Once we decide we're done, we stop incrementing skip
        [done, setDone] = useState(false);

    useEffect(() => {
        SetTitle("Films");
    }, []);

    useEffect(() => {
        if (done) return;
        if (filmsLoading) return;
        if (filmsError) return;

        const looksLikeFinalPage =
            films.length > 0 && films.length % TAKE !== 0;

        if (looksLikeFinalPage) {
            setDone(true);
            return;
        }

        // If we haven't loaded anything yet, don't bump skip preemptively.
        if (films.length === 0) return;

        const nextSkip = films.length;

        // StrictMode guard (and general sanity): don't request the same skip twice.
        if (lastRequestedSkipRef.current === nextSkip) return;
        lastRequestedSkipRef.current = nextSkip;

        setSkip(nextSkip);
    }, [films, filmsLoading, filmsError, done]);

    const gridIsLoading = films.length === 0 && filmsLoading;

    return (
        <>
            <SliderFeaturedContent
                sliderId={5}
                classNameInner="front-page"
                userDetails={userData}
            />

            <div className="page page--films">
                <h1>
                    All Films
                </h1>

                <VideoContentGridLandscape
                    isDarkMode={true}
                    carouselItems={films}
                    isLoading={gridIsLoading}
                    backgroundHex="#151515"
                />
            </div>
        </>
    );
}

export default FilmsFeed;
